import GState from "./__GState";

class NavX {

  static Goto(history, page, newTab = false, forceRefresh = false){
    if(GState.agent === "full"){
      GState.setAgent("side");
    }
    if(newTab){
      window.open(page, "_blank");
    }else{
      history?.push(page);
      if(forceRefresh){
        window.location.reload();
      }
    }
  }

  static Refresh(history){
    history?.go();
  }

  static NewWindow(url){
    window.open(url, "_blank");
  }

  static ClearParams(history){
    history?.replace({
      search: null,
    });
  }

}

export default NavX;